import { Component } from 'react'
import ReactGA from 'react-ga'
import withCookieAcceptance from 'components/withCookieAcceptance'
import setupGA from 'config/analytics'

class GoogleAnalytics extends Component {
  componentDidMount() {
    const { location: { pathname }, cookiesAccepted } = this.props

    if (cookiesAccepted) {
      setupGA()
      this.trackPage(pathname)
    }
  }

  componentDidUpdate({ location, cookiesAccepted: oldAccepted }) {
    const {
      location: { pathname: newPage },
      cookiesAccepted: newAccepted
    } = this.props
    const { pathname: oldPage } = location

    if (newAccepted && newAccepted !== oldAccepted) {
      setupGA()
    }

    if (newAccepted && (oldPage !== newPage || newAccepted !== oldAccepted)) {
      this.trackPage(newPage)
    }
  }

  trackPage(page) {
    ReactGA.set({ page })
    ReactGA.pageview(page)
  }

  render() {
    return null
  }
}

export default withCookieAcceptance(GoogleAnalytics)



// WEBPACK FOOTER //
// ./src/components/GoogleAnalytics.js